__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-20-1787219786-stable-dev/";